(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/config/menu-config/assets/javascripts/navigation-menu.js') >= 0) return;  svs.modules.push('/components/config/menu-config/assets/javascripts/navigation-menu.js');

'use strict';

var isUserNavMenuDoubleClick = false;
var trackAndNavigate = function trackAndNavigate(_ref) {
  var path = _ref.path,
    action = _ref.action;
  if (isUserNavMenuDoubleClick) {
    return;
  }
  isUserNavMenuDoubleClick = true;
  var track = {
    category: 'right menu',
    action: action,
    opt_label: action
  };
  svs.components.analytics.trackEvent(track, function () {
    isUserNavMenuDoubleClick = false;
    location.href = path;
  });
};
if (document.querySelector('.js-login-home-nav-menu')) {
  document.querySelector('.js-login-home-nav-menu').addEventListener('click', function () {
    var currentPath = svs.utils.url.currentPathEncodedParams();
    var path = "".concat(svs.core.urlMapping.get('loginHome'), "?extra=no&returnUrl=").concat(currentPath, "&cancelUrl=").concat(currentPath);
    trackAndNavigate({
      path: path,
      action: 'Logga in'
    });
  });
}
if (document.querySelector('.js-customer-reg-nav-menu')) {
  document.querySelector('.js-customer-reg-nav-menu').addEventListener('click', function () {
    var currentPath = svs.utils.url.currentPathEncodedParams();
    var path = "".concat(svs.core.urlMapping.get('customerRegistrationHome'), "?extra=no&returnUrl=").concat(currentPath, "&cancelUrl=").concat(currentPath);
    trackAndNavigate({
      path: path,
      action: 'Bli kund'
    });
  });
}

 })(window);